import React, {Component} from "react";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import {setItem, setPosition, setVisible} from "../ducks/itemhint";

class _ItemHint extends Component {
  handleMouseOver = () => {
    const {name: item, setItem, setVisible} = this.props;
    setVisible && setVisible(true);
    setItem && setItem(item);
  };

  handleMouseOut = () => {
    const {setVisible} = this.props;
    setVisible && setVisible(false);
  };

  handleMouseMove = ({clientX: x, clientY: y}) => {
    const {onMouseMove} = this.props;
    onMouseMove && onMouseMove({x, y});
  };

  render() {
    return <span
      onMouseOver={this.handleMouseOver}
      onMouseOut={this.handleMouseOut}
      onMouseMove={this.handleMouseMove}
    >{this.props.children}</span>;
  }
}

export const ItemHint = connect(
  null,
  (dispatch, props) => ({
    onMouseMove: ({x, y}) => dispatch(setPosition({x, y})),
    setVisible: visible => dispatch(setVisible(visible)),
    setItem: name => dispatch(setItem(name)),
  }),
)(_ItemHint);

ItemHint.propTypes = {
  name: PropTypes.string,
};
